/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useContext } from "react";
import { useOktaAuth } from "@okta/okta-react";
import config from "../../app/config";
import { RCLContext } from "../../components/RCL/RCLProvider";
import { Loader } from "../../components/Loader";
import PlatinumClub from "./PlatinumClub";
import PlatinumClubCtas from "./PlatinumClubCtas";

let styles;

(async () => {
  if (config.isWestJetMode) {
    styles = await import("./MyLoyaltyProgramVwq.module.scss");
  } else {
    styles = await import("./MyLoyaltyProgram.module.scss");
  }
})();

const MyLoyaltyProgramTabs = () => {
  const { authState, oktaAuth } = useOktaAuth();
  const [userInfo, setUserInfo] = useState(null);
  const { locale } = useContext(RCLContext);
  const [platinumClubInfo, setPlatinumClubInfo] = useState(null);
  const [platinumClubParagraph, setPlatinumClubParagraph] = useState(null);
  const [platinumClubFAQsParagraph, setPlatinumClubFAQsParagraph] =
    useState(null);
  const [notAStarMember, setNotAStarMember] = useState(null);
  const [isFAQModalOpen, setIsFAQModalOpen] = useState(false);

  function toggleFAQModal() {
    setIsFAQModalOpen(!isFAQModalOpen);
  }

  const platinumClubParagraphQuery = `
      query paragraphsData($locale: String, $skip:Int,$title: String, $brandCode:String!) {
        paragraphCollection(locale: $locale, limit:1, skip:$skip, where:{title:$title, brand: {brandCode:$brandCode} })
        {
          items
          {
            sys {
              id
            }
            heading
            content {
              json
            }
          }
        }
      }
    `;
  const platinumClubFAQsParagraphQuery = `
    query paragraphsData($locale: String, $skip:Int,$title: String, $brandCode:String!) {
      paragraphCollection(locale: $locale, limit:1, skip:$skip, where:{title:$title, brand: {brandCode:$brandCode} })
      {
        items {
          sys {
            id
          }
          heading
          content {
            json
          }
        }
      }
    }
  `;

  const notAStarMemberQuery = `
        query paragraphEntryQuery($locale: String) {
          paragraph(id: "6tqSLtUi7u6DRfoyDj9n1D", locale: $locale) {
            sys {
              id
            }
            heading
            content {
              json
            }
          }
        }
      `;

  const getPlatinumClubParagraph = async (token, locale) => {
    await fetch(config.resourceServer.contentfulApimAgentGqlUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        query: platinumClubParagraphQuery,
        variables: { 
          locale: locale === "fr" ? locale : "en-CA",
          "skip":0,
          title: "Group Sales Platinum Club",
          brandCode:config.brand ? config.brand.toUpperCase() : 'SWG'
        }
      }),
    })
      .then((response) => response.json())
      .then(({ data, errors }) => {
        if (errors) {
          console.error(errors);
        }
        setPlatinumClubParagraph(data.paragraphCollection?.items[0]);
      });
  };

  const getPlatinumClubFAQsParagraph = async (token, locale) => {
    await fetch(config.resourceServer.contentfulApimAgentGqlUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        query: platinumClubFAQsParagraphQuery,
        variables: { 
          locale: locale === "fr" ? locale : "en-CA",
          "skip":0,
          title: "Platinum Club Rewards FAQs",
          brandCode:config.brand ? config.brand.toUpperCase() : 'SWG'
        },
      }),
    })
      .then((response) => response.json())
      .then(({ data, errors }) => {
        if (errors) {
          console.error(errors);
        }
        setPlatinumClubFAQsParagraph(data.paragraphCollection?.items[0]);
      });
  };

  const getNotAStarMember = async (token, locale) => {
    await fetch(config.resourceServer.contentfulApimAgentGqlUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        query: notAStarMemberQuery,
        variables: { locale: locale === "fr" ? locale : "en-CA" },
      }),
    })
      .then((response) => response.json())
      .then(({ data, errors }) => {
        if (errors) {
          console.error(errors);
        }
        setNotAStarMember(data?.paragraph);
      });
  };

  const getPlatinumClubInfo = async (token) => {
    await fetch(
      `${config.resourceServer.agentApiUrl}/loyalty/PlatinumClubInfo`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((response) => {
        if (!response.ok) {
          return Promise.reject();
        }
        return response.json();
      })
      .then((data) => {
        setPlatinumClubInfo(data);
      });
  };


  useEffect(() => {
    if (!authState || !authState.isAuthenticated) {
      setUserInfo(null);
    } else {
      oktaAuth.getUser().then((info) => {
        setUserInfo(info);
        getPlatinumClubInfo(oktaAuth.getAccessToken());
        getPlatinumClubParagraph(oktaAuth.getAccessToken(), locale);
        getPlatinumClubFAQsParagraph(oktaAuth.getAccessToken(), locale);
        getNotAStarMember(oktaAuth.getAccessToken(), locale);
      });
    }
  }, [authState, oktaAuth, locale]);

  if (!userInfo || !platinumClubInfo) {
    return (
      <div className="star-balance__loader">
        <Loader />
      </div>
    );
  }

  return (
    <>
      {styles && 
        (<div className={config.isWestJetMode ? styles.myLoyaltyProgramVwq: ""}>
          {platinumClubInfo && platinumClubInfo.globalId && (
            <PlatinumClub
              platinumClubInfo={platinumClubInfo}
              toggleFAQModal={toggleFAQModal}
              isFAQModalOpen={isFAQModalOpen}
            ></PlatinumClub>
          )}
          <PlatinumClubCtas />
        </div>)}
    </>
  );
};

export default MyLoyaltyProgramTabs;
export { MyLoyaltyProgramTabs };
